import { TennisTournamentApi } from '@/api/validators/tennis';
import { StatusIds } from '@/helpers/sports';

export const convertTennisTournament = (tournament: TennisTournamentApi) => {
  return {
    ...tournament,
    venueName: tournament.venue.venueName ?? '',
    data: tournament.data.map((data) => ({
      ...data,
      matches: data.matches.map((match) => ({
        ...match,
        matchStatus: {
          id: getMatchStatusId(match.matchStatus),
          name: match.matchStatus,
        },
      })),
    })),
  };
};
export type TennisTournament = ReturnType<typeof convertTennisTournament>;
export type TennisTournamentRound = TennisTournament['data'][number];
export type TennisMatch = TennisTournamentRound['matches'][number];

const getMatchStatusId = (statusName: string) => {
  switch (statusName) {
    case 'Result':
    case 'Completed':
      return StatusIds.COMPLETED;
    case 'Live':
    case 'In Progress':
      return StatusIds.LIVE;
    case 'Upcoming':
    case 'Scheduled':
    default:
      return StatusIds.UPCOMING;
  }
};
